import { render } from "./SolveSettings.vue?vue&type=template&id=d4770462&scoped=true"
import script from "./SolveSettings.vue?vue&type=script&lang=js"
export * from "./SolveSettings.vue?vue&type=script&lang=js"

import "./SolveSettings.vue?vue&type=style&index=0&id=d4770462&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d4770462"

export default script